<div
  class="carousel"
  [class.disabled]="disabled()"
  [style.--visible-items]="effectiveVisibleItems()"
  [style.--carousel-gap.px]="gap()"
  [style.--shift]="currentIndex()"
>
  <div
    #viewport
    class="carousel-viewport"
    [class.disabled]="disabled()"
    (pointerdown)="handlePointerDown($event)"
    (pointermove)="handlePointerMove($event)"
    (pointerup)="handlePointerUp($event)"
    (pointerleave)="handlePointerUp($event)"
    (pointercancel)="handlePointerCancel()"
    (wheel)="handleWheel($event)"
  >
    <div
      class="carousel-track"
      [class.dragging]="dragging()"
      [style.transform]="transformValue()"
    >
      <ng-content/>
    </div>
  </div>
  @for (btn of actionCarouselButtons; track $index) {
    <button
      mat-icon-button
      class="carousel-arrow"
      [class]="btn.className"
      [disabled]="btn.action === 'prev' ? prevButtonDisabled() : nextButtonDisabled()"
      (click)="handleClick(btn.action)"
    >
      <mat-icon>{{ btn.icon }}</mat-icon>
    </button>
  }
</div>
